module.exports = __webpack_public_path__ + "static/media/under-construction.07a86062.jpg";